import { ApolloProvider as Provider } from "@apollo/client";
import { ReactNode, useMemo } from "react";
import { getApolloClient } from "./client";
import { useGetAccessToken } from "./getAccessToken";

type Props = {
  children: ReactNode;
};

export const ApolloProvider = ({ children }: Props) => {
  const { token } = useGetAccessToken();

  const apolloClient = useMemo(() => {
    return getApolloClient(token);
  }, [token]);

  return <Provider client={apolloClient}>{children}</Provider>;
};
